@if (!loading() && totalCount() > 0) {
  <div [class]="bannerClasses()" aria-live="polite">
    <i [class]="bannerIcon()"></i>
    <span class="font-medium">
      {{ bannerTitle() }}
    </span>
    <span class="ml-1 text-xs text-[var(--p-text-muted-color)] tabular-nums"> {{ readyCount() }}/{{ totalCount() }} pools ready </span>
    <span class="ml-auto flex flex-wrap items-center gap-1.5">
      @for (row of rows(); track trackByName($index, row)) {
        <span [class]="chipClasses(row)" [title]="row.name + (row.isReady ? ' (Real)' : ' (Standard fallback)')">
          @if (row.isReady) {
            <i class="pi pi-check" style="font-size: 0.65rem"></i>
          } @else {
            <i class="pi pi-circle" style="font-size: 0.65rem"></i>
          }
          {{ row.name }}
        </span>
      }
    </span>
  </div>
}
